<template>
    <div class="pushManage">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>互动直播</el-breadcrumb-item>
            <el-breadcrumb-item>PUSH管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="live-list">
                <el-select v-model="user.current" clearable filterable placeholder="请选择创建者或输入关键字">
                    <el-option v-for="userItem in user.list" :key="userItem.userId" :label="userItem.userName" :value="userItem"></el-option>
                </el-select>
                <el-select v-model="live.current" clearable filterable placeholder="请选择直播或输入关键字" @change="changeLive">
                    <el-option v-for="liveItem in formatLiveList" :key="liveItem.topicId" :label="liveItem.liveTitle" :value="liveItem"></el-option>
                </el-select>
            </div>
            <div class="push-info-box" v-if="push.list">
                <div class="refresh-btn-box" @click="refreshPushInfo">
                    <img src="../../../assets/refresh.png" alt="刷新">
                </div>
                <ul>
                    <li class="push-info-item-box" v-for="(pushInfoItem, index) in formatPushInfo">
                        <div class="push-info-item">
                            <div class="text">{{pushInfoItem.cText}}</div>
                            <div :class="'image-box' + ' ' + 'has-item-' + pushInfoItem.sourceUrl.length" v-if="pushInfoItem.sourceUrl">
                                <img v-for="(imageItem, arrIndex) in pushInfoItem.sourceUrl" v-bind:src="imageItem" alt="一点资讯" >
                            </div>
                            <div class="source-info">{{pushInfoItem.createTime}}</div>
                            <div class="options-box">
                                <el-button type="primary" icon="delete" size="small" @click="deletePushInfo(pushInfoItem.contentId)"></el-button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="add-push-box" v-if="live.current">
                <div class="head">发布内容</div>
                <div class="body">
                    <el-form ref="pushForm" :model="push.form" label-width="85px" label-position="top">
                        <el-form-item label="文本内容">
                            <el-input type="textarea" v-model="push.form.text"></el-input>
                        </el-form-item>
                        <el-form-item prop="newsContentImage">
                            <div class="label">
                                图片链接
                                <el-button type="primary" size="small" @click="addImageInputBox">+</el-button>
                            </div>
                            <template v-for="(imgItem, index) in push.form.imgList">
                                <div class="image-input-item-box">
                                    <el-input class="image-url-box"  v-model="push.form.imgList[index]"></el-input>
                                    <el-button type="primary" icon="delete" @click="deleteImageInputBox(index)"></el-button>
                                </div>
                            </template>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addPushInfo">立即创建</el-button>
                            <el-button @click="clearPushFormData">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: 'pushManage',
    data(){
        return {
            user: {
                current: null,
                list: null
            },
            live: {
                current: null,
                list: null
            },
            push: {
                list: null,
                form: {
                    text: null,
                    imgList: null
                }
            }
        };
    },
    computed:{
        formatLiveList(){
            if (!this.user.current) {
                return this.live.list;
            } else {
                let userId = this.user.current.userId;
                let liveList = this.live.list;
                return liveList.filter((liveItem)=>{
                    return liveItem.creator === userId;
                });
            }
        },
        formatPushInfo(){
            if (!this.push.list) {
                return null;
            } else {
                let pushInfoList = this.push.list;
                return pushInfoList.filter((pushInfoItem)=>{
                    if (pushInfoItem.sourceUrl) {
                        if (pushInfoItem.sourceUrl.indexOf(';') !== -1) {
                            pushInfoItem.sourceUrl = pushInfoItem.sourceUrl.split(';');
                        } else {
                            pushInfoItem.sourceUrl = [pushInfoItem.sourceUrl];
                        }
                    }
                    return true;
                });
            }
        }
    },
    mounted(){
        this._init();
    },
    methods: {
        _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.user.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getLiveList(){
            this.$http.post(CONFIG.HOST + '/live/liveTextList' + '?t=' + TOOL.getCurrentTime(), {
                liveSource: '图文直播'
            }).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.live.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getPushInfoList(liveId = -1){
            this.$http.get(CONFIG.HOST + "/live/liveContent/listLiveContent/" + liveId).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    if (result.data.length > 0) {
                        this.push.list = result.data;
                        this.$message.success("【营销平台】成功获取PUSH信息");
                    } else {
                        this.$message.info("【营销平台】暂无PUSH内容");
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        _deletePush(contentId = -1){
            this.$http.delete(CONFIG.HOST + '/live/liveContent/deleteLiveContent/' + contentId).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功删除contentId=' + contentId + '的PUSH内容'
                    });
                    this._getPushInfoList(this.live.current.id);
                } else {
                    
                }
            },(response)=>{
                console.log(response);
            });
        },
        _addPushInfo(pushForm){
            if (pushForm) {
                this.$http.post(CONFIG.HOST + '/live/liveContent/addLiveContent', pushForm).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】内容PUSH成功'
                        });
                        this._getPushInfoList(this.live.current.id);
                        this.clearPushFormData();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response)=>{
                    console.log(response);
                });
            }
        },
        _init(){
            this._getUserList();
            this._getLiveList();
        },
        changeLive(liveItem){
            this.push.list = null;
            this._getPushInfoList(this.live.current.id);
        },
        deletePushInfo(contentId = -1){
            this._confirmMessage('是否确定删除contentId=' + contentId + '的PUSH内容？', ()=>{
                if (contentId < 0) {
                    this.$notify.error({
                        message: '【营销平台】contentId=' + contentId + '的PUSH内容'
                    });
                    return;
                }
                this._deletePush(contentId);
            });
        },
        deleteImageInputBox(arrIndex = -1){
            this.push.form.imgList.splice(arrIndex, 1);
            if (this.push.form.imgList.length === 0) {
                this.push.form.imgList = null;
            }
        },
        addImageInputBox(){
            if (Array.isArray(this.push.form.imgList)) {
                if (this.push.form.imgList.length >= 3) {
                    this.$notify.warning({
                        message: '【营销平台】最多可添加三张图片'
                    });
                    return;
                } else {
                    this.push.form.imgList.push(null);
                }
            } else {
                this.push.form.imgList = [null];
            }
        },
        clearPushFormData(){
            let formData = this.push.form;
            formData.text = null;
            formData.imgList = [null];
        },
        addPushInfo(){
            let pushForm = this.push.form;
            if (!pushForm.text && !pushForm.imgList) {
                this.$notify.error({
                    message: '【营销平台】PUSH内容不可为空，至少填一项'
                });
                return;
            }
            try {
                let formData = {
                    cText: pushForm.text,
                    sourceUrl: null,
                    liveId: this.live.current.id,
                    cType: '纯文'
                };
                if (Array.isArray(pushForm.imgList)) {
                    let flagNum = 0;
                    let imgArr = pushForm.imgList.filter((arrItem)=>{
                        if (!arrItem || !(arrItem = arrItem.trim())) {
                            return false;
                        }
                        return true;
                    });

                    formData.sourceUrl = imgArr.join(';');
                    
                    if (formData.sourceUrl.length && formData.cText &&(formData.cText = formData.cText.trim())) {
                        formData.cType = '图文';
                    } else if(formData.sourceUrl.length) {
                        formData.cType = '纯图';
                    } else {
                        formData.cType = '纯文';
                    }                  
                }
                this._addPushInfo(formData);
            } catch (error) {
                console.log(error);
            }
        },
        refreshPushInfo(){
            this._getPushInfoList(this.live.current.id);
        }
    }
}
</script>
<style lang="less">
    .pushManage{
        ul, ol, li{
            list-style-type: none;
        }
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .content-box{
            height: 100%;

            .live-list{
                width: 30%;
                height: 85%;

                float: left;

                text-align: left;
                border-right:1px #efefef solid;
                .el-select{
                    width: 90%;
                    margin-bottom: 20px;
                }
            }
            .push-info-box{
                width: 320px;
                height: 560px;

                position: relative;
                float: left;
                margin-left: 30px;

                border: 1px solid #000;
                overflow-y: auto;

                .refresh-btn-box{
                    width: 40px;
                    height: 40px;

                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 10000;

                    border-radius: 50%;

                    background: #fff;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .push-info-item-box{
                    padding: 0 10px;

                    margin-bottom: 10px;

                    .push-info-item{
                        text-align: left;
                        border-bottom: 1px solid #ccc;
                        padding-bottom: 6px;
                        
                        .text{

                        }
                        img{
                            width: 100%;
                        }
                        .has-item-1{
                            img {
                                width: 100%;
                            }
                        }
                        .has-item-2{
                            img {
                                width: 48%;
                            }
                            img:nth-child(1){
                                margin-right: 4%;
                            }
                        }
                        .has-item-3{
                            img {
                                width: 30%;
                            }
                            img:nth-child(1){
                                margin-right: 3.3%;
                            }
                            img:nth-child(2){
                                margin-right: 3.3%;
                            }
                        }
                        .source-info{
                            font-size: 13px;
                        }
                    }
                    
                }
            }
            .add-push-box{
                width: 340px;
                text-align: left;

                float: left;
                margin-left: 20px;

                border: 1px solid #bfcbd9;
                .head{
                    padding: 10px 14px;
                
                    border-bottom: 1px solid #bfcbd9;
                    
                    text-align: left;
                    color: rgb(51, 51, 51);
                }
                .body{
                    padding: 20px 14px 0;
                    textarea {
                        height: 160px;
                    }
                    .label{
                        button{
                            border-radius: 50%;
                        }
                    }
                    .image-input-item-box{
                        margin-bottom: 10px;
                        .image-url-box{
                            width: 83%;
                        }
                    }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// Push.vue?2c60b218